import React from 'react';
import { Label } from '@nooz-optics/nooz-components-lib';

export const UserDetailsHeader = ({ label }) => (
  <div className='pb-12'>
    <div className='w-full border-b pb-3'>
      <Label
        {...label}
        weight='bold'
        size='4xl'
      />
    </div>
  </div>
);
